import React, { FunctionComponent } from 'react';
import TemplateVersionToDownload from 'reports/components/TemplateVersionToDownload';
import { useParams } from 'react-router-dom';

const ReportStoreVersion: FunctionComponent = () => {
  const { id, moduleName } = useParams<{ id: string; moduleName: string }>();

  return (
    <div id="report-template-version">
      <TemplateVersionToDownload id={id} moduleName={moduleName} />
    </div>
  );
};

export default ReportStoreVersion;
